import { Kbd } from "@nexxt/ui";

// The keys of the app's shortcuts, written once: the handlers in shortcuts.ts (and undo-shortcut.ts for ⌘Z, ADR-282)
// listen for them, and the tooltips, ⌘K and the list of `?` show them (design-system.md §4.10, ADR-114).

export const shortcutKeys = {
  palette: ["⌘K"],
  search: ["/"],
  rail: ["["],
  help: ["?"],
  undo: ["⌘Z"],
} as const;

/** `g` then the key of a place. */
export const goToKeys = (key: string) => ["G", key.toUpperCase()];

/** The keys of a shortcut pressed one after the other (`G` then `L`). */
export function ShortcutKeys({ keys }: { keys: readonly string[] }) {
  return (
    <span className="flex items-center gap-0.5">
      {keys.map((key) => (
        <Kbd key={key}>{key}</Kbd>
      ))}
    </span>
  );
}
